import { AIError } from './errors.js';
export function parseRequest(schema, value) {
    const parsed = schema.safeParse(value);
    if (!parsed.success) {
        // Zod issue paths contain no prompt text, schema contents or credentials.
        const fields = [...new Set(parsed.error.issues.map(issue => issue.path.join('.') || 'request'))];
        throw new AIError(`Invalid AI request: ${fields.join(', ')}.`, 'invalid_request', 400);
    }
    return parsed.data;
}
export function parseResponse(schema, value) {
    const parsed = schema.safeParse(value);
    if (!parsed.success) {
        throw new AIError('The API returned an invalid response.', 'invalid_response', 502);
    }
    return parsed.data;
}
